import { REMOTE_SUPPORT_URL, PHONE, PHONE_HREF, EMAIL } from "@/data/content";

export default function Footer() {
  return (
    <footer
      className="border-t border-white/10"
      data-testid="site-footer"
    >
      <div className="mx-auto flex max-w-[1440px] flex-col gap-6 px-6 py-10 md:flex-row md:items-center md:justify-between md:px-12">
        <div className="flex items-center gap-4">
          <img
            src="/opus-logo.png"
            alt="Opus Consulting, LLC"
            className="h-8 w-auto brightness-[1.7] saturate-[1.1]"
          />
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#A0A0A0]">
            © {new Date().getFullYear()} Opus Consulting, LLC
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-x-8 gap-y-3 font-mono text-[11px] uppercase tracking-[0.25em] text-[#A0A0A0]">
          <a
            href={PHONE_HREF}
            className="transition-colors duration-300 hover:text-white"
            data-testid="footer-phone-link"
          >
            {PHONE}
          </a>
          <a
            href={`mailto:${EMAIL}`}
            className="transition-colors duration-300 hover:text-white"
            data-testid="footer-email-link"
          >
            {EMAIL}
          </a>
          <a
            href={REMOTE_SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0033FF] transition-colors duration-300 hover:text-white"
            data-testid="footer-remote-support-link"
          >
            Remote Support
          </a>
        </div>
      </div>
    </footer>
  );
}
